import React, { useEffect, useState } from 'react';
import { Button, Form, Drawer, Steps } from 'antd';
import { observer } from 'mobx-react';
import FormComponent from './FormComponent.js';
import useStore from '../../../../store';
import {
	displayFormats,
	Notification,
	templeSteps,
} from '../../../../config/Global';
import Message from '../../../../config/Message';
import moment from 'moment';
import RoutineForm from './RoutineFormComponent.js';
import TempleImageUpload from './ImageUpload.js';

const AddComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const { AUTH, TEMPLE } = useStore();
	const [current, setCurrent] = useState(0);
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);
	const [formID, setFormID] = useState('AddForm');
	const [isLiveDarshan, setIsLiveDarshan] = useState(false);
	const [cameraAllowed, setCameraAllowed] = useState(false);
	const [fileLists, setFileLists] = useState({});
	const [tempState, setTempState] = useState(true);
	const [templeID, setTempleID] = useState(null);
	const [templeStep, setTempleStep] = useState(templeSteps);
	const {
		AUTH: { stateList, cityList },
	} = useStore();
	const [propertyOverView, setPropertyOverView] = useState({})
	const [propertyOptions, setPropertyOptions] = useState({})
	// const [SEOData, setSEOData] = useState({
	// 	metaTitle: 'templeName Information, Darshan Timings, Live Darshan',
	// 	metaKeywords: 'Temples in cityName, Temples in stateName',
	// 	metaDescription:
	// 		'Find information about templeName Darshan Timing, Aarti Timing, Live Darshan and near by places to visit. Also, find a comfortable Dharamshala and hotel near templeName',
	// });
	// const [isChecked, setIsChecked] = useState(false);

	const [tempNamee, setTempName] = useState();
	const [stateName, setStateName] = useState();
	const [cityName, setCityName] = useState();

	// const testBlurEv = () => {
	// 	const {
	// 		templeName,
	// 		eCityId,
	// 		eStateId,
	// 		metaTitle,
	// 		metaDescription,
	// 		metaKeywords,
	// 	} = form.getFieldsValue();
	// 	let getStateName = stateList.find(
	// 		(_X) => _X.eRegionId === eStateId
	// 	)?.regionName;
	// 	let getCityName = cityList.find(
	// 		(_X) => _X.eRegionId === eCityId
	// 	)?.regionName;
	// 	let metaKeywordsdd = metaKeywords;
	// 	metaKeywordsdd = metaKeywordsdd.replace(
	// 		stateName ? stateName : 'stateName',
	// 		getStateName || 'stateName'
	// 	);
	// 	metaKeywordsdd = metaKeywordsdd.replace(
	// 		cityName ? cityName : 'cityName',
	// 		getCityName || 'cityName'
	// 	);
	// 	form.setFieldsValue({
	// 		metaTitle: metaTitle.replace(
	// 			new RegExp(tempNamee ? tempNamee : 'templeName', 'g'),
	// 			templeName || 'templeName'
	// 		),
	// 		metaDescription: metaDescription.replace(
	// 			new RegExp(tempNamee ? tempNamee : 'templeName', 'g'),
	// 			templeName || 'templeName'
	// 		),
	// 		metaKeywords: metaKeywordsdd,
	// 	});
	// 	setTempName(templeName);
	// 	setStateName(getStateName);
	// 	setCityName(getCityName);
	// };

	const handleBasicDetailsSubmit = (data) => {
		setSaving(true);
		let payload = {
			...data,
			isLiveDarshan: isLiveDarshan,
			cameraAllowed: cameraAllowed,
			// metaTitle: isChecked ? data.metaTitle : null,
			// metaKeywords: isChecked ? data.metaKeywords : null,
			// metaDescription: isChecked ? data.metaDescription : null,
			seoTitle: data.seoTitle || null,
			faQs: data.faqs.length ? JSON.stringify(data.faqs) : null,
			faQsSchema: data.faQsSchema ? data.faQsSchema.replace(/(\r\n|\n|\r)/g, '') || '' : '',
			propertyOverview: JSON.stringify(propertyOverView),
			nearByProperty: JSON.stringify(propertyOptions)
		};
		delete data.faqs
		TEMPLE.addTemple(payload)
			.then((data) => {
				if (typeof data !== 'string') {
					Notification.success({
						message: Message().CRUD.ADD("Temple's Basic Details"),
					});
					setCurrent(1);
					AUTH.lookupKeyList = [];
					setTempleStep((prev) => {
						const updatedArray = [...prev];
						updatedArray[0] = {
							...updatedArray[0],
							status: 'finish',
						};
						return updatedArray;
					});
					setPropertyOverView({})
					setPropertyOptions({})
					setFormID('RoutineForm');
					setDisabled(true);
					setTempleID(data.data);
					AUTH.getAllByLookupKeyList(
						`lookupKey=TEMPLETIMINGTYPE&isAdmin=false`
					);
				} else {
					Notification.error({
						message: data,
					});
				}
			})
			.catch((e) => { })
			.finally(() => setSaving(false));
	};

	const handleChange = () => {
		setTempState(!tempState);
		if (formID === 'TempleImageUploadForm') {
			setTimeout(() => {
				form.validateFields({ validateOnly: true })
					.then(() => {
						if (form.getFieldsValue().templeImageList.length) {
							if (
								form.getFieldsValue().templeImageList.length ===
								Object.keys(fileLists).length
							) {
								setDisabled(false);
							} else {
								setDisabled(true);
							}
						} else {
							setDisabled(true);
						}
					})
					.catch(() => {
						// setDisabled(true);
					});
			}, 0);
		} else if (formID === 'RoutineForm') {
			setTimeout(() => {
				form.validateFields({ validateOnly: true })
					.then(() => {
						if (
							form.getFieldsValue().templeTimingAddModelList
								.length
						) {
							setDisabled(false);
						} else {
							setDisabled(true);
						}
					})
					.catch(() => {
						// setDisabled(true);
					});
			}, 0);
		} else {
			setTimeout(() => {
				form.validateFields({ validateOnly: true })
					.then(() => {
						setDisabled(false);
					})
					.catch((err) => {
						setDisabled(true);
					});
			}, 0);
		}
	};

	const handleRoutineSubmit = (data) => {
		setSaving(true);
		if (
			data.templeTimingAddModelList &&
			data.templeTimingAddModelList.length
		) {
			data.templeTimingAddModelList.forEach((_X, index) => {
				data.templeTimingAddModelList[index]['eTempleId'] = templeID;
				data.templeTimingAddModelList[index]['fromTime'] = moment(
					data.templeTimingAddModelList[index]['time'][0]['$d']
				).format(displayFormats.TIME_FORMAT);
				data.templeTimingAddModelList[index]['toTime'] = moment(
					data.templeTimingAddModelList[index]['time'][1]['$d']
				).format(displayFormats.TIME_FORMAT);
				delete data.templeTimingAddModelList[index]['time'];
			});
		}
		TEMPLE.addRoutine(data?.templeTimingAddModelList)
			.then((data) => {
				if (typeof data !== 'string') {
					AUTH.lookupKeyList = [];
					setCurrent(2);
					Notification.success({
						message: Message().CRUD.ADD("Temple's Routine"),
					});
					setFormID('TempleImageUploadForm');
					// AUTH.getAllByLookupKeyList(
					// 	`lookupKey=IMAGETYPE&isAdmin=false`
					// );
					setTempleStep((prev) => {
						const updatedArray = [...prev];
						updatedArray[0] = {
							...updatedArray[1],
							status: 'finish',
						};
						return updatedArray;
					});
					setDisabled(true);
				} else {
					Notification.error({
						message: data,
					});
				}
			})
			.catch((e) => { })
			.finally(() => setSaving(false));
	};

	const TempleImageUploadSubmit = async (data) => {
		setSaving(true);
		await data.templeImageList.forEach(async (item) => {
			const formData = new FormData();
			formData.append('RefTablename', 'temple');
			formData.append('ERefRecordid', templeID);
			Object.keys(item).forEach((keyName) => {
				if (['Description', 'ImageType'].includes(keyName)) {
					formData.append(keyName, item[keyName]);
				} else {
					formData.append(
						'Imagefile',
						item.fileList.fileList[0].originFileObj
					);
				}
			});
			await AUTH.ImageUpload(formData)
				.then((data) => {
					if (typeof data !== 'string') {
						setCurrent(0);
					} else {
						Notification.error({
							message: data,
						});
					}
				})
				.catch((e) => { })
				.finally(() => setSaving(false));
		});
		Notification.info({ message: 'Image uploading start in background.' });
		AUTH.lookupKeyList = [];
		setTempleStep(templeSteps);
		setFormID('AddForm');
		setTempleID(null);
		closeModal();
		setSaving(false);
	};

	const closeModal = () => {
		setFormID('AddForm');
		TEMPLE.agGrid.api.resetColumnState();
		TEMPLE.setupGrid(TEMPLE.agGrid);
		form.resetFields();
		setDisabled(true);
		AUTH.lookupKeyList = [];
		AUTH.stateList = [];
		AUTH.cityList = [];
		setFileLists({});
		TEMPLE.templeBasicDetail = null;
		TEMPLE.templeTimingDetail = null;
		TEMPLE.templeImageDetails = null;
		setCurrent(0);
		onClose();
	};

	// useEffect(() => {
	// 	form.setFieldsValue(SEOData);
	// }, [SEOData]);

	return (
		<Drawer
			title="Add Temple"
			onClose={closeModal}
			open={visible}
			destroyOnClose
			width={'75%'}
			footer={
				<div style={{ textAlign: 'right' }}>
					{/* <Button type="primary" key={1} disabled={disabled}>
						Prev
					</Button> */}
					<Button
						type="primary"
						key={2}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form={formID}
					>
						{templeStep.length - 1 === current
							? 'Upload & Submit'
							: 'Save & Next'}
					</Button>
					<Button
						key={3}
						onClick={closeModal}
						style={{ marginLeft: '20px' }}
					>
						Cancel
					</Button>
				</div>
			}
		>
			<Steps
				items={templeStep}
				current={current}
				style={{
					marginBottom: 24,
				}}
			/>
			{current === 0 ? (
				<FormComponent
					id="AddForm"
					form={form}
					onFinish={handleBasicDetailsSubmit}
					handleChange={handleChange}
					isLiveDarshan={isLiveDarshan}
					setIsLiveDarshan={setIsLiveDarshan}
					cameraAllowed={cameraAllowed}
					setCameraAllowed={setCameraAllowed}
					propertyOverView={propertyOverView}
					setPropertyOverView={setPropertyOverView}
					propertyOptions={propertyOptions}
					setPropertyOptions={setPropertyOptions}
				// testBlurEv={testBlurEv}
				// isChecked={isChecked}
				// setIsChecked={setIsChecked}
				/>
			) : current === 1 ? (
				<RoutineForm
					id="RoutineForm"
					form={form}
					onFinish={handleRoutineSubmit}
					handleChange={handleChange}
					initialValues={{ templeTimingAddModelList: [{}] }}
					loading={saving}
				/>
			) : current === 2 ? (
				<TempleImageUpload
					id="TempleImageUploadForm"
					form={form}
					onFinish={TempleImageUploadSubmit}
					handleChange={handleChange}
					fileLists={fileLists}
					setFileLists={setFileLists}
					initialValues={{ templeImageList: [{}] }}
				/>
			) : null}
		</Drawer>
	);
});

export default AddComponent;
